import { render, staticRenderFns } from "./ProCard.vue?vue&type=template&id=62e50a2e&"
import script from "./ProCard.vue?vue&type=script&async=true&lang=js&"
export * from "./ProCard.vue?vue&type=script&async=true&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports